import { useMemo } from 'react';

import { useGetPropertyLovs } from '../proposal.slice';

type PropertyLovs = {
  geoLocations: Record<string, string>;
  planCovers: Record<string, string>;
};

export function usePropertyLovs(isProperty: boolean, planID?: string) {
  const { data } = useGetPropertyLovs({
    variables: { planID: String(planID ?? '') },
    skip: !planID || !isProperty
  });

  const propertyLovs: PropertyLovs = useMemo(() => {
    const geoLocations = (data?.production?.getGeoLocations ?? []).reduce(
      (acc: Record<string, string>, g: any) => {
        acc[String(g.id)] = String(g.title ?? g.code ?? g.id);

        return acc;
      },
      {}
    );

    const planCovers = (
      data?.planConfig?.getPlanPlanCovers?.items ?? []
    ).reduce((acc: Record<string, string>, item: any) => {
      const id = String(item?.id ?? '');
      if (!id) return acc;
      const code = item?.cover?.code ?? item?.coverID ?? '';
      const name = item?.cover?.name ?? '';
      const label = [code, name].filter(Boolean).join(' - ') || id;
      acc[id] = label;

      return acc;
    }, {});

    return { geoLocations, planCovers };
  }, [data]);

  return propertyLovs;
}
